module.exports = __webpack_public_path__ + "img/oaks-nest-living-1.62494da9.jpeg";